export default "__VITE_ASSET__Bw7lQSaa__"